<div class="main row">
  <div class="margin-bottom-10">
    <div id="verify-method"><router-outlet></router-outlet></div>
  </div>
</div>
